import { useProfileStore } from "@/store/useProfileStore";

export const useProfile = () => {
  const { profile, setProfile } = useProfileStore();
  return { profile, setProfile };
};
